// Demo data so the site stays browsable when the API is unreachable.
// Ported from the mobile app's src/api/demo.js.

export const categories = [
  { key: 'maid', label: 'House Maid', icon: '🧹', tint: '#FDECEE' },
  { key: 'cook', label: 'Cook', icon: '🍳', tint: '#FCF3E2' },
  { key: 'baby', label: 'Babysitter', icon: '👶', tint: '#E7EFFC' },
  { key: 'elder', label: 'Elderly Care', icon: '🧓', tint: '#E5F5EE' },
  { key: 'house', label: 'Housekeeping', icon: '🏠', tint: '#FBE6E9' },
  { key: 'fulltime', label: 'Full-Time Maid', icon: '🕐', tint: '#F3ECFB' },
];

export const demoPackages = [
  { _id: 'p1', title: '24-Hour Live-in Maid', category: 'Full-Time Maid', durationType: 'daily', price: 1200, isPopular: true, features: ['Cooking', 'Cleaning', 'Laundry'] },
  { _id: 'p2', title: 'Part-Time Maid (Weekly)', category: 'Part-Time Maid', durationType: 'weekly', price: 1500, discountPrice: 1299, features: ['2 hrs/day', 'Cleaning'] },
  { _id: 'p3', title: 'Monthly Cook Service', category: 'Cook', durationType: 'monthly', price: 8000, isPopular: true, features: ['2 meals/day', 'Custom menu'] },
  { _id: 'p4', title: 'Babysitter (Monthly)', category: 'Babysitter', durationType: 'monthly', price: 15000, features: ['Trained nanny', 'Daytime care'] },
  { _id: 'p5', title: 'Elderly Care (Monthly)', category: 'Elderly Care', durationType: 'monthly', price: 18000, features: ['Attendant', 'Medication reminders'] },
];

export const demoJobs = [
  { _id: 'j1', bookingCode: 'NRYK22B', packageTitle: '24-Hour Live-in Maid', staffPay: 12000, status: 'in_progress', customer: { name: 'Priya Singh' }, address: { city: 'Pune', pincode: '411001' } },
  { _id: 'j2', bookingCode: 'NRYK19X', packageTitle: 'Monthly Cook Service', staffPay: 9000, status: 'in_progress', customer: { name: 'Amit Verma' }, address: { city: 'Pune', pincode: '411014' } },
];

export const demoEarnings = {
  totalCredited: 46000,
  monthlyAgreed: 21000,
  activeJobs: 2,
  completedJobs: 4,
  salaryHistory: [
    { bookingCode: 'NRYK22B', title: '24-Hour Live-in Maid', amount: 12000, month: 'Jun 2026', creditedAt: '2026-06-05' },
    { bookingCode: 'NRYK19X', title: 'Monthly Cook Service', amount: 9000, month: 'Jun 2026', creditedAt: '2026-06-05' },
    { bookingCode: 'NRYK22B', title: '24-Hour Live-in Maid', amount: 12000, month: 'May 2026', creditedAt: '2026-05-05' },
  ],
};
